<div *ngIf="state.step < 5" class="wrapper-sign-up">	
	<div class="section-title">
		<div class="row">
			<div class="col">
				<div class="d-flex align-items-center">
					<a routerLink="/dashboard/domain" class="btn btn-back" [attr.aria-label]="'Back' | translate">
						<i class="fi-rr-arrow-alt-left"></i>
					</a>
					<div class="title" [attr.data-parent]="'Domain' | translate">{{ "Add Domain" | translate }}</div>
				</div>
			</div>
		</div>
  </div>

    <div class="section-sign-up-step container-xl" [class.step4-container]="state.step == 4" [formGroup]="storeForm">
        <div class="card card-form">

            <!-- Step 1 -->
            <div *ngIf="state.step == 1">
                <!-- <h5 class="card-subtitle">Step 1</h5> -->
                <h1 class="card-title mb-1">{{ "New or Existing domain?" | translate }}</h1>
                <h3 class="text-center mb-0 card-title-2">{{ "Register new domain or use your existing domain?" | translate }}</h3>
                <div class="form mt-3">

                    <div class="form-group container-fluid">
                        <!-- <label class="form-label pl-2 pl-sm-1 mb-3">Choose a plan</label> -->

                        <div class="row">

                            <label class="form-check-label col-12  is-loading"
                                [class.selected]="!useExistingDomain.value">
                                <div class="row">
                                    <div class="col-12 select-option">
                                        <div class="row">
                                            <input class="form-check-input d-none" type="radio" [value]="false"
                                                formControlName="useExistingDomain">
                                            <div class="select-option-checkbox">
                                                <i
                                                    [class]="'las ' + (!useExistingDomain.value?'la-check-circle':'las la-circle')"></i>
                                            </div>
                                            <div class="col align-self-center">
                                                {{ "Register New Domain" | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </label>

                            <label class="form-check-label col-12" [class.selected]="useExistingDomain.value">
                                <div class="row">
                                    <div class="col-12 select-option">
                                        <div class="row">
                                            <input class="form-check-input d-none" type="radio" [value]="true"
                                                formControlName="useExistingDomain">
                                            <div class="select-option-checkbox">

                                                <i
                                                    [class]="'las ' + (useExistingDomain.value?'la-check-circle':'las la-circle')"></i>

                                            </div>
                                            <div class="col align-self-center">
                                                {{ "Use Existing Domain" | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </label>

                        </div>
                    </div>

                    <div
                        class="d-flex">
                        <button routerLink='/dashboard/domain' class="btn btn-red secondary mr-2">{{ "Cancel" | translate }}</button>
                        <button (click)="nextStep()" class="btn btn-primary">{{ "Next" | translate }}</button>
                    </div>

                </div>
            </div>


            <!-- Step 2 -->
            <div *ngIf="state.step == 2">
                <!-- <h5 class="card-subtitle">Step 2</h5> -->
                <h1 class="card-title mb-1">{{ "Register New Domain" | translate }}</h1>
                <h3 class="text-center mb-0 card-title-2">{{ "Enjoy this extra Essential perk & choose your very own domain
                    name!" | translate }}</h3>
                <div class="form mt-3">
                    <div class="form-group" *ngIf="useCustomDomain.value">
                        <label class="form-label">{{ "Domain Name" | translate }} <span placement="top" ngbTooltip=".com"><i
                                    class="fas fa-info-circle"></i></span></label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="custom-domain-prepend">www.</span>
                            </div>
                            <input type="text" class="form-control store-custom-domain"
                                [class.is-invalid]="customDomain.touched && customDomain.invalid"
                                formControlName="customDomain" (keyup.enter)="validateDomain()"
                                oninput="this.value = this.value.toLowerCase()" placeholder="5s-store.com">

                            <div class="invalid-feedback" *ngIf="customDomain.invalid">
                                <ng-container *ngIf="customDomain.errors.required || customDomain.errors.pattern">
                                    {{ "Please provide a valid custom domain." | translate }} 
                                </ng-container>
                                <ng-container *ngIf="customDomain.errors.taken">
                                    <div class="domain-textbox">{{ "Domain is not available." | translate }} </div>
                                    <div *ngFor="let s of suggest" class="suggest-textbox"><span
                                            style="text-align: right; font-size: 16px; color: #747e8b;">{{ "Suggest domain" | translate }} :
                                        </span>{{s}}
                                        <div>
                                            <button (click)="selectbtn(s)"
                                                class="btn btn-blue-small btn-sm">{{ "Select" | translate }}</button>
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <button (click)="prevStep()" class="btn btn-setup secondary mr-2">{{ "Back" | translate }}</button>
                        <button (click)="validateDomain()" class="btn btn-setup"
                            [disabled]="!canValidateDomain">{{ "Next" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div *ngIf="state.step == 3">
                <!-- <h5 class="card-subtitle">Step 3</h5> -->
                <h1 class="card-title mb-1">{{ "Add Existing Domain" | translate }}</h1>
                <h3 class="text-center mb-0 card-title-2">{{ "Use your existing domain for your EStore!" | translate }}</h3>
                <div class="form mt-3">
                    <div class="form-group" *ngIf="useCustomDomain.value">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="custom-domain-prepend">www.</span>
                            </div>
                            <input type="text" class="form-control store-custom-domain"
                                [class.is-invalid]="customDomain.touched && customDomain.invalid"
                                formControlName="customDomain" (keyup.enter)="validateExistingDomain()"
                                oninput="this.value = this.value.toLowerCase()" placeholder="5s-store.com">

                            <div class="invalid-feedback" *ngIf="customDomain.invalid">
                                <div class="domain-textbox">
                                    
                                    <ng-container *ngIf="customDomain.errors.required || customDomain.errors.pattern">
                                        <span>{{ "Please provide a valid custom domain." | translate }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="customDomain.errors.minlength">
                                        <span>{{ "Domain must be at least " + customDomain.errors.minlength.requiredLength + " characters long." | translate }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="customDomain.errors.maxlength">
                                        <span>{{ "Domain cannot exceed " + customDomain.errors.maxlength.requiredLength + " characters." | translate }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="customDomain.errors.server_error">                                        
                                        <span>{{ customDomain.errors.server_error | translate }}</span>
                                    </ng-container>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="d-flex justify-content-between">
                        <button (click)="prevStep()" class="btn btn-setup secondary mr-2">{{ "Back" | translate }}</button>
                        <button (click)="validateExistingDomain()" class="btn btn-setup"
                            [disabled]="!canValidateDomain">{{ "Next" | translate }}</button>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<div class="site-footer__anchor" *ngIf="state.step == 4">
    <button type="button" title="Back to top" class="site-footer__back-to-top" [class.--is-active]="backToTopIsActive"
        [class.--is-absolute]="backToTopIsAbsolute" (click)="scrollToTop(templateContent)"></button>
</div>

<div *ngIf="state.step == 5" class="wrapper-ready">

    <div class="section-title row">
        <div class="section-btn">
            <button routerLink='/dashboard/domain' class="btn btn-back rounded-circle mt-2">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <div class="title">{{ "Create Custom Domain" | translate }}</div>
        </div>
    </div>

    <div class="section-ready container-xl">
        <div class="d-flex justify-content-center">
            <h1 class="title">
                <!-- <span class="text-blue">Get ready</span> for your first sale.
                <img class="yellow-line" src="../../assets/yellow-line.png" alt="line"> -->
                {{ "It's almost time to" | translate }}<span class="text-blue"> {{ "ADD YOUR CUSTOM DOMAIN!" | translate }}</span>
                <img class="yellow-line" src="../../assets/yellow-line.png" alt="line">
            </h1>
        </div>
        <div class="row section-content">
            <div class="section-image col-12 col-sm-12 col-md-12 col-lg-6">
                <img class="ready-image" src="../../assets/ready-image.png" alt="ready-1">
            </div>
            <div class="section-text col-12 col-sm-12 col-md-8 col-lg-6">
                <p class="subtitle">
                    {{ "Welcome on-board! Get ready to embark on an amazing journey of great growth and connection with
                    FIV5S." | translate }}
                </p>
                <div class="section-cards summary-cards">
                    <div class="card summary-card" *ngIf=false>
                        <div class="row">
                            <!-- <div class="w-15">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="w-40">
                                <p class="title">Your Store's Name</p>
                            </div>
                            <div>
                                <p class="subtitle">{{form.value.name}}</p>
                            </div> -->
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Store Name" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ form.value.name }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card" *ngIf="storeUrl">
                        <div class="row">
                            <!-- <div class="w-15">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="w-40">
                                <p class="title">Your Store's URL</p>
                            </div>
                            <div class="w-60">
                                <p class="subtitle">{{ storeUrl }}</p>
                            </div> -->
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Store URL" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ storeUrl }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card" *ngIf=false>
                        <div class="row">
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Subdomain URL" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ subdomainName.value + '.' + storeSubdomain}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card" *ngIf=false>
                        <div class="row">
                            <!-- <div class="w-15">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="w-40">
                                <p class="title">Subscribed Plan</p>
                            </div>
                            <div>
                                <p class="subtitle"><strong>{{ form.value.plan.plan_name }}</strong><br>
                                    ({{ form.value.plan.plan_price == 0 ? 'Free!' : ((form.value.plan.plan_price | currency:'MYR':'RM ') + '/month') }})
                                </p>
                            </div> -->

                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Subscribed Plan" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle"><strong>{{ form.value.plan.plan_name }}</strong><br>
                                    ({{ form.value.plan.plan_price == 0 ? 'Free!' : ((form.value.plan.plan_price |
                                    currency:'MYR':'RM ') + '/month') }})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="card summary-card" *ngIf=false>
                        <div class="row">
                            <!-- <div class="w-15">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="w-40">
                                <p class="title">Email Address</p>
                            </div>
                            <div>
                                <p class="subtitle">{{form.value.email}}</p>
                            </div> -->
                            <div class="col-1">
                                <div class="check-mark"><i class="fas fa-check-circle"></i></div>
                            </div>
                            <div class="col-4">
                                <p class="title">{{ "Email Address" | translate }}</p>
                            </div>
                            <div class="col-7 text-right">
                                <p class="subtitle">{{ form.value.email }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="section-btn mt-5 justify-content-between">
                        <button (click)="prevStep()" class="btn btn-proceed gray">{{ "Return" | translate }}</button>
                        <button class="btn btn-proceed" (click)="createCustomDomain()"
                            [disabled]="state.submitting">{{ "Proceed" | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #customDomainContent let-modal>
    <div class="modal-body text-center my-4">
        <div class="spinner-border text-success" role="status"></div>
        <p class="mt-3">
            <ng-container *ngIf="state.step == 0">{{ "Validating email address" | translate }}</ng-container>
            <ng-container *ngIf="state.step == 3">
                {{ "Validating" | translate }} {{ validatingSubDomain?'sub-':''}}{{ "domain" | translate }}
            </ng-container>
            <ng-container *ngIf="state.step == 5">{{ "Creating store" | translate }}</ng-container>
            {{ "Checking domain, please wait..." | translate }}
        </p>
    </div>
</ng-template>